import { linksUpTo } from './_shared';

/** **チェーンに乗った**（Issue #589）。分岐は無い。事実: `chain` / `links`（このリンクまで）/ `player` `code` `uid` */
export default Object.freeze({
  event: 'chained',
  label: 'チェーンに乗った',
  variants: Object.freeze([]),
  classify({ payload }) {
    const chain = Number(payload?.link?.chain ?? payload?.chain) || 0;
    const links = linksUpTo(payload);
    const me = links.find((l) => l.chain === chain);
    if (!chain || !me) return null;
    return {
      ...payload, chain, links, player: me.player, code: me.code, uid: payload?.link?.uid ?? payload?.uid ?? null,
    };
  },
});
